import classnames from 'classnames';
import { useSelector } from 'react-redux';
import {
  Navigate, Outlet, useLocation, useNavigate,
} from 'react-router-dom';
import { Container, Col, Row } from 'reactstrap';

import './AuthLayout.scss';

import { IRootState } from '@app/store';
import ReforalLogo from '@assets/img/reforal-logo.svg';
import LocaleService from '@services/LocaleService';
import sanitizeReturnTo from '@shared/helpers/navigation';
import { CustomButton } from '@shared/buttons';
import {
  // FloorIcon,
  // RIllustrationIcon,
  // RPlantIcon, RLampIcon,
  BackIcon,
  // ReforalIcon,
} from '@shared/icons';

interface LeftColumnContentProps {
  isRegisterContent: boolean;
  isRegister: boolean;
  nav: (path: string) => void;
}

interface RightColumnContentProps {
  isRegisterContent: boolean;
  isRegister: boolean;
}

const i18n = LocaleService.getTranslations('general');

const LeftColumnContent = ({
  isRegisterContent, isRegister, nav,
}: LeftColumnContentProps) => {
  const renderCol = {
    registerContent: () => (
      <Col className="auth-back-btn-container d-flex flex-column left-container justify-content-between" lg={2}>
        <div className="d-flex flex-column left-container h-100 auth-back-btn-div">
          <CustomButton
            id="btn-back"
            className="btn-lg register-content-back-btn"
            color="secondary"
            onClick={() => nav('/auth/register')}
          >
            <BackIcon /> {i18n.button.back}
          </CustomButton>
        </div>
      </Col>
    ),
    register: () => (
      <Col xl={2} className="d-flex flex-column left-container justify-content-between">
        <div>
          <div
            className={classnames('auth-back-btn-container', {
              'register-back-btn': isRegister,
            })}
          >
            <CustomButton
              id="btn-back"
              className="btn-lg auth-back-btn"
              color="secondary"
              onClick={() => nav('/auth/login')}
            >
              <BackIcon /> {i18n.button.back_to_login}
            </CustomButton>
          </div>
        </div>
        {/* <div className="register-left-assets icon-container-style">
          <RIllustrationIcon />
        </div> */}
      </Col>
    ),
    // default is for login page
    default: () => (
      <Col lg={6} className="">
        <div className="login-logo">
          <div
            className="login-reforal-container"
          >
            <span>
              {/* <ReforalIcon width="110" height="auto" /> */}
              <img src={ReforalLogo} alt="Reforal Logo" width="100px" />
            </span>
            <span className="reforal-title">
              {i18n.header.title}
            </span>
          </div>
        </div>
      </Col>
    ),
  };
  if (isRegisterContent) return renderCol.registerContent();
  if (isRegister) return renderCol.register();
  return renderCol.default();
};

const RightColumnContent = ({
  isRegisterContent, isRegister,
}: RightColumnContentProps) => {
  const renderCol = {
    registerContent: () => (
      <Col md={2} />
    ),
    // register: () => (
    //   <Col lg={3}
    // className="d-xl-flex d-lg-none flex-column align-items-center justify-content-between">
    //     <div className="d-flex" />
    //     <div className="register-right-assets icon-container-style">
    //       <RPlantIcon />
    //       <RLampIcon />
    //     </div>
    //   </Col>
    // ),
    register: () => (
      <Col md={2} />
    ),
    // default is for login page
    default: () => null,
  };
  if (isRegisterContent) return renderCol.registerContent();
  if (isRegister) return renderCol.register();
  return renderCol.default();
};

const AuthLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLogin = location.pathname.includes('login');
  const isRegister = location.pathname.endsWith('register');
  const isRegisterContent = location.pathname.includes('dentist')
  || location.pathname.includes('dental-clinic')
  || location.pathname.includes('laboratory');

  // const isLoggedIn = useSelector((state: IRootState) => state.Auth.accessToken);
  const isLoggedIn = useSelector((state: IRootState) => state.Auth.user.id);

  const queryReturnTo = new URLSearchParams(location.search).get('returnTo');
  const returnTo = sanitizeReturnTo(queryReturnTo || localStorage.getItem('lastPage'));

  if (isLoggedIn) {
    return <Navigate to={returnTo} state={{ from: location }} />;
  }

  const contentCol = () => {
    if (isRegisterContent || isRegister) {
      return 8;
    }

    return 6;
  };

  return (
    <Container
      fluid
      className={classnames('auth-container', {
        'register-logo': isRegister,
      })}
    >
      <Row className="min-vh-100">
        <LeftColumnContent
          isRegisterContent={isRegisterContent}
          isRegister={isRegister}
          nav={navigate}
        />
        <Col
          className="form-container"
          lg={12}
          // xl={isRegisterContent ? 8 : 6}
          xl={contentCol()}
        >
          <div
            className={classnames('d-flex flex-column align-items-center h-100', {
              'login-container-padding': isLogin,
            })}
          >
            <div
              className={classnames('title-container', {
                'remove-title-margin': isRegisterContent,
              })}
            >
              <span>
                {/* <ReforalIcon width="60" height="auto" /> */}
                <img src={ReforalLogo} alt="Reforal Logo" width="60px" />
              </span>
              <span className="title">
                {i18n.header.title}
              </span>
            </div>
            <Outlet />
          </div>
        </Col>
        <RightColumnContent
          isRegisterContent={isRegisterContent}
          isRegister={isRegister}
        />
      </Row>
      {/* {
        !isRegisterContent && !isLogin && (
          <Row className="floor-row-container icon-container-style">
            <Col className="text-center">
              <FloorIcon />
            </Col>
          </Row>
        )
      } */}
      {/* {(isLogin || !isRegister) && <div className="divider" />} */}
    </Container>
  );
};

export default AuthLayout;
